<template>
	<common-card
		v-bind="$attrs"
		v-on="$listeners"
		@click="goToFilteredView"
	>
		<img :src="iconSrc" :alt="typeLabel">
		<h5>{{ typeLabel }}</h5>
		<slot/>
	</common-card>
</template>

<script>
export default {
	inheritAttrs : false,
	props        : {
		/**
		 * The template type.
		 */
		type : {
			type     : String,
			required : true,
		},
		/**
		 * The template type name.
		 */
		typeLabel : {
			type     : String,
			required : true,
		},
	},
	computed : {
		iconSrc (type) {
			const svgs = require.context('../../assets/images/icons/', false, /\.svg$/)
			return svgs(`./${this.type}-icon.svg`)
		},
	},
	methods : {
		goToFilteredView () {
			this.$store.dispatch('templates/goToFilteredView', { type: this.type })
		},
	},
}
</script>
